/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  IAnalyticsWidgetMethods,
  AnalyticeWidgetService,
  IStaticPageContentMethods,
  StaticPageContentService,
  IPresentationMethods,
  PresentationService,
  ITableMethods,
  TableService
} from "./components";

export type MasqueraderReportAgent = IHeaderMethods &
  IAnalyticsWidgetMethods &
  ITableMethods &
  IPresentationMethods & 
  IStaticPageContentMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new AnalyticeWidgetService(),
    new StaticPageContentService(),
    new TableService(),
    new PresentationService(),
  ];
};

export const getAgent = () => {
  return createAgent<MasqueraderReportAgent>({
    plugins: getPlugins(),
  });
};
